module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/contactbanner.jpg"),
      "alt": "contactbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("联系我们")])], 1)])])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit"
  }, [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "ctactit"
  }, [_c('h1', [_vm._v("北京泽浩天科技发展有限公司")]), _vm._v(" "), _c('span', [_vm._v("BEIJING ZEHAOTIAN TECHNOLOGY CO. LTD.")])]), _vm._v(" "), _c('div', {
    staticClass: "ctactcon clearfix"
  }, [_c('div', {
    staticClass: "ditu pull-left"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctactwrap pull-right"
  }, [_c('ul', [_c('li', [_vm._v("联系人：王经理")]), _vm._v(" "), _c('li', [_vm._v("电话：010-67047381，010-61807868")]), _vm._v(" "), _c('li', [_vm._v("邮箱：zehaotian@139.com")]), _vm._v(" "), _c('li', [_vm._v("地址：北京市门头沟区熙旺中心A座1026 ")]), _vm._v(" "), _c('li', [_vm._v("微信号： ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-top": "3px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/qrcode.png",
      "alt": "feed"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4684bdeb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactUs.vue
// module id = 305
// module chunks = 2